import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventBroadcastService } from '../../../services/event-broadcast.service';
import { ProtuneApiService } from '../../../services/protune-api.service';
import { User } from '../../../models/user';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { CommonModule, Location, formatDate } from '@angular/common';
import { PagedDataResult } from '../../../models/paged-data-result';
import { SavedSettings } from '../../../models/saved-settings';
import moment from 'moment';

@Component({
  selector: 'app-user-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './user-detail.component.html',
  styleUrl: './user-detail.component.scss'
})
export class UserDetailComponent {
  userId: string;
  user: User;
  savedSettings: PagedDataResult<SavedSettings>
  savedSuccess: boolean;
  savedFailed: boolean;
  savedErrorMessage: string;

  userForm: FormGroup;

  constructor(private modalService: NgbModal,
    private eventBroadcastService: EventBroadcastService,
    private protuneApiService: ProtuneApiService,
    private router: Router,
    private fb: FormBuilder,
    private location: Location) {
    this.userForm = this.fb.group({
      id: [''],
      userName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      subscriptionLevel: ['', Validators.required],
      customerId: [''],
      isEnabled: [false],
      aieExpirationDate: [''],
      aieCancelledDate: [{ value: '', disabled: true }],
      aieMonthlyRequests: [''],
      aieLastRequestedDate: [{value: '', disabled: true}]
    }, {
      validators: this.aieExpirationRequired.bind(this)
    });
  }

  private aieExpirationRequired(group: AbstractControl): ValidationErrors | null {
    if (this.user?.hasAIEngineerSubscription && !group.get('aieExpirationDate')?.value) {
      return { aieExpirationRequired: true };
    }
    return null;
  }

  ngOnInit(): void {
    if (history.state.userId) {
      this.userId = history.state.userId;

      this.protuneApiService.getUser(this.userId).subscribe({
        next: res => {
          this.user = res;
          this.patchForm();
        }, error: err => console.log(err)
      });

      this.protuneApiService.getSavedSettingsByUser(this.userId).subscribe({
        next: res => {
          this.savedSettings = res;
          console.log(res);
        },
        error: err => console.log(err)
      });
    }
  }

  onSubmit(): void {
    this.savedFailed = false;
    this.savedSuccess = false;
    this.savedErrorMessage = '';

    if (this.userForm.valid) {
      debugger;
      this.protuneApiService.updateUser(this.userForm.value).subscribe({
        next: updatedUser => {
          this.user = updatedUser;
          this.patchForm();

          this.savedSuccess = true;
        },
        error: err => {
          this.savedFailed = true;
          this.savedErrorMessage = err.error.detail ?? err.error.title;
          console.log(err)
        }
      });
    }
    
  }

  cancel(): void {
    this.savedSuccess = false;
    this.savedFailed = false;
    this.savedErrorMessage = '';

    this.userForm.reset(this.user);
    this.user.hasAIEngineerSubscription = this.user.aieExpirationDate != null;
    this.patchForm();
  }

  patchForm(): void {
    this.userForm.patchValue({
      ...this.user,
      aieExpirationDate: this.user.aieExpirationDate
        ? new Date(this.user.aieExpirationDate).toISOString().split('T')[0]
        : null,
      aieCancelledDate: this.user.aieCancelledDate
        ? new Date(this.user.aieCancelledDate).toISOString().split('T')[0]
        : null,
      aieLastRequestedDate: this.user.aieLastRequestedDate
        ? formatDate(this.user.aieLastRequestedDate, 'yyyy-MM-dd HH:mm:ss a', 'en-US')
        : null
      });
    }

  goBack(): void {
    this.location.back();
  }
    
  addAIEngineerSubscription(): void {
    if (!this.user.hasAIEngineerSubscription) {
      this.user.hasAIEngineerSubscription = true;
      this.userForm.controls['aieExpirationDate'].patchValue(moment().add(1, "month").toISOString().split('T')[0]);
      this.userForm.controls['aieMonthlyRequests'].patchValue(0);

  }
  }

}
